/** Help §5.11 — The Inbox (`inbox/InboxView.tsx`, `inbox/inboxModel.ts`). */
import { helpSectionMeta } from '../help-sections.js';
import { Btn, Bullets, Callout, HelpSectionCard, Li, P, Shot, SubHead } from '../HelpPrimitives.js';

export function Inbox(): React.JSX.Element {
  return (
    <HelpSectionCard meta={helpSectionMeta('inbox')}>
      <Shot
        slug="inbox"
        caption="The Inbox — the message list on the left, the selected email and its actions on the right."
      />

      <SubHead>How new mail arrives</SubHead>
      <P>
        The app already checks all connected mailboxes for new mail automatically every few minutes,
        so new emails usually show up on their own. Click <Btn>Check Mail</Btn> when you don’t want
        to wait — it fetches your own mailbox immediately.
      </P>

      <SubHead>Tabs</SubHead>
      <P>
        <Btn>All</Btn>, <Btn>Unclassified</Btn>, <Btn>New Projects</Btn> and <Btn>Linked</Btn>.
      </P>
      <P>
        New emails are sorted into <Btn>Unclassified</Btn> / <Btn>New Projects</Btn> /{' '}
        <Btn>Linked</Btn> by a simple rule based on the sender and the subject line — for example,
        an email from an unknown sender with no existing project is treated as a possible
        new-project candidate. It’s a fixed rule, not an AI judgement, so an odd subject line can
        land in the wrong tab; just use <Btn>Create Project</Btn> / <Btn>Link to Project</Btn> to
        fix it manually.
      </P>

      <SubHead>What you can do with an email</SubHead>
      <Bullets>
        <Li>
          Already linked to a project — <Btn>Open Project</Btn> or <Btn>Unlink</Btn>.
        </Li>
        <Li>
          Not linked yet — <Btn>Link to Project</Btn> or <Btn>Create Project</Btn>.
        </Li>
        <Li>
          <Btn>Reply</Btn> is always available.
        </Li>
        <Li>
          Find an old message with <Btn>Search emails…</Btn>.
        </Li>
      </Bullets>

      <Callout tone="change" title="Moved">
        The <Btn>Check Mail</Btn> button now lives inside the Inbox itself — top right of the filter
        bar — instead of in the sidebar.
      </Callout>
    </HelpSectionCard>
  );
}
